// Footer.jsx - COMPLET AVEC TRADUCTION
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from '@emailjs/browser';
import { useTranslation } from 'react-i18next';
// Dans Footer.jsx
import { EMAILJS_CONFIG } from '../../config/emailConfig';

const Footer = () => {
  const { t } = useTranslation();
  
  // Icônes SVG inline
  const Icons = {
    Cross: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
      </svg>
    ),
    TikTok: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    YouTube: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
    Instagram: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
    Spotify: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
    Phone: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    Mail: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
      </svg>
    ),
    Location: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
      </svg>
    ),
    Heart: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    ),
    ArrowUp: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
      </svg>
    )
  };

  // Liens rapides
  const quickLinks = [
    { path: '/', label: t('footer.quickLinks.home') },
    { path: '/about', label: t('footer.quickLinks.about') },
    { path: '/music', label: t('footer.quickLinks.music') },
    { path: '/books', label: t('footer.quickLinks.books') },
    { path: '/worship', label: t('footer.quickLinks.worship') },
    { path: '/eaj', label: t('footer.quickLinks.eaj') },
    { path: '/support', label: t('footer.quickLinks.support') },
    { path: '/contact', label: t('footer.quickLinks.contact') }
  ];

  // Services/Ministères
  const ministries = [
    { label: t('footer.ministries.worship'), desc: t('footer.ministries.worshipDesc') },
    { label: t('footer.ministries.school'), desc: t('footer.ministries.schoolDesc') },
    { label: t('footer.ministries.cafe'), desc: t('footer.ministries.cafeDesc') },
    { label: t('footer.ministries.music'), desc: t('footer.ministries.musicDesc') },
    { label: t('footer.ministries.counseling'), desc: t('footer.ministries.counselingDesc') },
    { label: t('footer.ministries.prayer'), desc: t('footer.ministries.prayerDesc') }
  ];

  // Réseaux sociaux
  const socialLinks = [
    { platform: 'YouTube', icon: <Icons.YouTube />, url: 'https://youtube.com/@esaie_wilondja?si=NJpFAib1Apm9_dN9', color: 'hover:text-red-500' },
    { platform: 'TikTok', icon: <Icons.TikTok />, url: 'https://www.tiktok.com/@esaiewilondja?is_from_webapp=1&sender_device=pc', color: 'hover:text-blue-500' },
    { platform: 'Vevo', icon: <Icons.YouTube />, url: 'https://youtube.com/@esaiewiondjavevo?si=lOZYm_b4K759NAKX', color: 'hover:text-pink-500' },
    { platform: 'Spotify', icon: <Icons.Spotify />, url: 'https://open.spotify.com/intl-fr/artist/3Wi2QtUBfyY54IdnbNzoT2', color: 'hover:text-green-500' }
  ];

  // États pour la newsletter
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  // Retour en haut de page
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Dans Footer.jsx - MODIFIEZ la fonction handleNewsletterSubmit
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    
    // Validation email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setSubmitStatus({ 
        type: 'error', 
        message: t('footer.newsletter.validation.invalidEmail') 
      });
      return;
    }

    // Vérifier si l'email est déjà enregistré (simulation avec localStorage)
    const subscribedEmails = JSON.parse(localStorage.getItem('newsletter_subscribers') || '[]');
    
    if (subscribedEmails.includes(email.toLowerCase())) {
      setSubmitStatus({ 
        type: 'warning', 
        message: t('footer.newsletter.validation.alreadySubscribed') 
      });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      // Envoyer l'email de confirmation
      const result = await emailjs.send(
        EMAILJS_CONFIG.SERVICE_ID,
        EMAILJS_CONFIG.TEMPLATE_NEWSLETTER,
        {
          to_email: email,
          user_email: email,
          reply_to: email,
          from_name: t('footer.newsletter.email.fromName'),
          to_name: t('footer.newsletter.email.toName'),
          date: new Date().toLocaleDateString('fr-FR'),
          time: new Date().toLocaleTimeString('fr-FR', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })
        },
        EMAILJS_CONFIG.PUBLIC_KEY
      );

      console.log('Succès EmailJS:', result);

      // Ajouter l'email à la liste des inscrits (localStorage)
      const updatedEmails = [...subscribedEmails, email.toLowerCase()];
      localStorage.setItem('newsletter_subscribers', JSON.stringify(updatedEmails));

      // Succès
      setEmail('');
      setSubmitStatus({ 
        type: 'success', 
        message: t('footer.newsletter.successMessage') 
      });

      setTimeout(() => {
        setSubmitStatus({ type: '', message: '' });
      }, 5000);

    } catch (error) {
      console.error('Erreur EmailJS:', error);
      
      let errorMessage = t('footer.newsletter.error.general');
      if (error.text && error.text.includes('quota')) {
        errorMessage = t('footer.newsletter.error.quota');
      }
      
      setSubmitStatus({ 
        type: 'error', 
        message: errorMessage 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-b from-black to-gray-900 text-white pt-16 pb-8 border-t border-gray-800">
      <div className="container mx-auto px-4">
        {/* Section principale */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10 mb-12">
          {/* Logo et description */}
          <div className="space-y-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="flex items-center space-x-3"
            >
              <div className="w-16 h-16 rounded-xl flex items-center justify-center overflow-hidden border-2 border-yellow-600">
                <img 
                  src="/assets/images/EsaieMusiclogo.jpg" 
                  alt="Logo Esaie Wilondja"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-white font-serif">
                  Esaie<span className="text-yellow-600">Wilondja</span>
                </h2>
                <p className="text-sm text-gray-400">{t('footer.ministry')}</p>
              </div>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-gray-400 leading-relaxed"
            >
              {t('footer.description')}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="space-y-3"
            >
              <div className="flex items-center space-x-3 text-gray-300">
                <Icons.Phone className="w-5 h-5 text-yellow-600" />
                <span>{t('footer.contact.phone')}</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <Icons.Mail className="w-5 h-5 text-yellow-600" />
                <span>{t('footer.contact.email')}</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <Icons.Location className="w-5 h-5 text-yellow-600" />
                <span>{t('footer.contact.location')}</span>
              </div>
            </motion.div>
          </div>

          {/* Liens rapides */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h3 className="text-xl font-bold text-white mb-6 pb-3 border-b border-gray-800">
              {t('footer.quickLinks.title')}
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <motion.li
                  key={link.path}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                >
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-yellow-600 transition-colors duration-300 flex items-center group"
                  >
                    <span className="w-2 h-2 bg-yellow-600 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.label}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Services/Ministères */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3 className="text-xl font-bold text-white mb-6 pb-3 border-b border-gray-800">
              {t('footer.ministries.title')}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {ministries.map((ministry, index) => (
                <motion.div
                  key={ministry.label}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.05 }}
                  className="p-3 rounded-lg bg-gradient-to-r from-gray-900/50 to-black/50 border border-gray-800 hover:border-yellow-500/30 transition-all duration-300"
                >
                  <div className="flex items-start space-x-3">
                    <Icons.Cross className="w-4 h-4 text-yellow-600 mt-1 flex-shrink-0" />
                    <div>
                      <h4 className="font-semibold text-white text-sm">{ministry.label}</h4>
                      <p className="text-gray-500 text-xs">{ministry.desc}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Newsletter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h3 className="text-xl font-bold text-white mb-6 pb-3 border-b border-gray-800">
              {t('footer.newsletter.title')}
            </h3>
            <p className="text-gray-400 mb-6">
              {t('footer.newsletter.description')}
            </p>
            
            <form onSubmit={handleNewsletterSubmit} className="space-y-4">
              <div>
                <input
                  type="email"
                  placeholder={t('footer.newsletter.placeholder')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg focus:outline-none focus:border-yellow-600 focus:ring-2 focus:ring-yellow-500/20 text-white placeholder-gray-500 transition-all duration-300"
                  required
                  disabled={isSubmitting}
                />
              </div>

              <AnimatePresence>
                {submitStatus.message && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    className={`p-3 rounded-lg ${submitStatus.type === 'success' 
                      ? 'bg-green-900/20 border border-green-800/30 text-green-400' 
                      : submitStatus.type === 'warning'
                      ? 'bg-yellow-900/20 border border-yellow-800/30 text-yellow-400'
                      : 'bg-red-900/20 border border-red-800/30 text-red-400'
                    }`}
                  >
                    <div className="flex items-center space-x-2">
                      {submitStatus.type === 'success' ? (
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                        </svg>
                      ) : submitStatus.type === 'warning' ? (
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                        </svg>
                      ) : (
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                        </svg>
                      )}
                      <span className="text-sm">{submitStatus.message}</span>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full bg-gradient-to-r from-yellow-600 to-yellow-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 flex items-center justify-center space-x-2 ${
                  isSubmitting 
                    ? 'opacity-70 cursor-not-allowed' 
                    : 'hover:shadow-xl hover:shadow-yellow-500/20 hover:scale-105'
                }`}
              >
                {isSubmitting ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                    <span>{t('footer.newsletter.submitting')}</span>
                  </>
                ) : (
                  <>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <span>{t('footer.newsletter.subscribe')}</span>
                  </>
                )}
              </button>
            </form>

            {/* Réseaux sociaux */}
            <div className="mt-8">
              <h4 className="font-semibold text-white mb-4">{t('footer.social.follow')}</h4>
              <div className="flex space-x-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.platform}
                    href={social.url}
                    className={`w-10 h-10 flex items-center justify-center rounded-lg bg-gray-900 border border-gray-800 ${social.color} transition-all duration-300 hover:scale-110 hover:shadow-lg`}
                    aria-label={social.platform}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 my-8"></div>

        {/* Bas du footer */}
        <div className="flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-center lg:text-left"
          >
            <p className="text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} {t('footer.copyright')}
            </p>
            <p className="text-gray-600 text-xs mt-2">
              {t('footer.designedWith')} <Icons.Heart className="inline w-3 h-3 text-red-500" /> {t('footer.forGlory')}
            </p>
          </motion.div>

          <div className="flex items-center space-x-6 text-sm text-gray-500">
            <h3>
              {t('footer.developedBy')}{" "}
              <a
                href="mailto:danielnibango6@gmail.com"
                className="text-blue-600 hover:underline cursor-pointer"
              >
                danielnibango6@gmail.com
              </a>
            </h3>
          </div>

          {/* Bouton retour en haut */}
          <motion.button
            onClick={scrollToTop}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-yellow-600 to-yellow-700 text-white hover:shadow-xl hover:shadow-yellow-500/30 transition-all duration-300"
            aria-label={t('footer.scrollToTop')}
          >
            <Icons.ArrowUp />
          </motion.button>
        </div>

        {/* Message biblique */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mt-12 pt-8 border-t border-gray-800 text-center"
        >
          <div className="flex items-center justify-center space-x-3 mb-3">
            <Icons.Cross className="w-5 h-5 text-yellow-600" />
            <p className="text-gray-400 italic text-sm">
              {t('footer.bibleVerse.text')}
            </p>
            <Icons.Cross className="w-5 h-5 text-yellow-600" />
          </div>
          <p className="text-gray-600 text-xs">
            {t('footer.bibleVerse.description')}
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;